import { useState } from "react";
import { CampoNumero, Resultado, Dato, Rejilla, mxn } from "../components/campos.jsx";
import { calcularTarifaFreelance } from "../lib/calc.js";

export default function Freelance() {
  const [neto, setNeto] = useState(30000);
  const [gastos, setGastos] = useState(5000);
  const [impuesto, setImpuesto] = useState(30);
  const [semanasLibres, setSemanasLibres] = useState(4);
  const [horasSemana, setHorasSemana] = useState(40);
  const [aprovechamiento, setAprovechamiento] = useState(70);

  const r = calcularTarifaFreelance({
    netoDeseadoMensual: neto,
    gastosOperativosMensuales: gastos,
    impuestoPct: impuesto,
    semanasLibresAlAnio: semanasLibres,
    horasPorSemana: horasSemana,
    aprovechamientoPct: aprovechamiento,
  });

  return (
    <div className="space-y-6">
      <Rejilla>
        <div className="space-y-4">
          <CampoNumero
            label="Sueldo neto mensual deseado"
            valor={neto}
            onChange={setNeto}
            prefijo="$"
            min={0}
            ayuda="Lo que quieres que te quede limpio."
          />
          <CampoNumero label="Gastos operativos mensuales" valor={gastos} onChange={setGastos} prefijo="$" min={0} />
          <CampoNumero label="Impuesto / ISR estimado" valor={impuesto} onChange={setImpuesto} sufijo="%" min={0} max={99} />
          <CampoNumero label="Semanas libres al año" valor={semanasLibres} onChange={setSemanasLibres} min={0} max={30} step="1" />
          <CampoNumero label="Horas de trabajo por semana" valor={horasSemana} onChange={setHorasSemana} min={1} max={90} step="1" />
          <CampoNumero
            label="Tiempo realmente facturable"
            valor={aprovechamiento}
            onChange={setAprovechamiento}
            sufijo="%"
            min={10}
            max={100}
            ayuda="Las juntas, la administración y buscar clientes no se cobran. Un 70% es realista."
          />
        </div>

        <div className="order-first space-y-3 lg:order-last lg:col-span-2">
          <Resultado label="Tu tarifa por hora" valor={mxn(r.tarifaHora)} tono="positivo" />

          <div className="grid gap-3 sm:grid-cols-2">
            <div className="tarjeta">
              <h3 className="mb-2 text-2xs font-bold uppercase tracking-wider texto-3">Tarifas</h3>
              <Dato label="Por hora" valor={mxn(r.tarifaHora)} destacar />
              <Dato label="Por día (8 h)" valor={mxn(r.tarifaDia)} />
              <Dato label="Por semana" valor={mxn(r.tarifaSemana)} />
            </div>
            <div className="tarjeta">
              <h3 className="mb-2 text-2xs font-bold uppercase tracking-wider texto-3">De dónde sale</h3>
              <Dato label="Necesitas facturar al mes" valor={mxn(r.brutoMensual)} />
              <Dato label="Al año" valor={mxn(r.brutoAnual)} />
              <Dato label="Horas facturables al año" valor={`${Math.round(r.horasFacturables)} h`} />
            </div>
          </div>

          <p className="text-2xs texto-3">
            Esta tarifa ya cubre tus gastos, tus impuestos y las semanas que no trabajas. Cobrar por
            debajo significa financiar a tu cliente con tus vacaciones.
          </p>
        </div>
      </Rejilla>
    </div>
  );
}
